// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"615":"6b90b6a0","766":"b45bcea4","887":"239741fb","892":"636e97bc","987":"96f19056"}[chunkId] + ".chunk.js";
};